import { useSelector } from 'react-redux';

import {
  selectDashboardDateRangeSelection,
  selectDashboardResultType,
  selectDashboardListOrderBy,
  selectDashboardPerScopeValueList,
} from '@reducers/v2/dashboard/dashboard.slice';
import { useGetDashboardOverall, useGetDashboardPerScopeValueList } from '@api/modules/dashboard/hooks';
import { DashboardResultType } from '@api/domain/types';
import type { DashboardScope, DashboardDrilldownFilter } from '@api/domain/types';

export interface UseManageDashboardDrilldownListParams {
  childScope: DashboardScope;
  drilldownFilter: DashboardDrilldownFilter;
}

export const useManageDashboardDrilldownList = ({ childScope, drilldownFilter }: UseManageDashboardDrilldownListParams) => {
  const { from, to } = useSelector(selectDashboardDateRangeSelection);
  const resultType = useSelector(selectDashboardResultType);
  const orderBy = useSelector(selectDashboardListOrderBy);
  const { pageNumber } = useSelector(selectDashboardPerScopeValueList);

  const isDiverging = resultType !== DashboardResultType.Actual;

  const { data: overall, loading: overallLoading } = useGetDashboardOverall({
    scope: childScope,
    resultType,
    from,
    to,
    drilldownFilter,
    enabled: isDiverging,
  });

  const list = useGetDashboardPerScopeValueList({
    scope: childScope,
    resultType,
    from,
    to,
    orderBy,
    drilldownFilter,
  });

  return { resultType, orderBy, from, to, pageNumber, overall, overallLoading, list };
};
